/**
 * Cart form( set current cart items)
 */

const MS_APP_PROXY_PATH = '/apps/multi_suppliers';
// const MS_CART_TMP_ITEMS_KEY = 'MS_CART_TMP_ITEMS';

// const expr = '.js-vendor-cart-quantity-input';
// const storageKey = MS_CART_TMP_ITEMS_KEY;


// function setCurrnetCartItems() {
//   if (location.pathname != '/cart') return;
//   const cartData = []
//   $(expr).each(function (key, element) {
//     const $element = $(element);

//     console.log(element);
//     cartData[$element.data('product-vendor')] ||= {};
//     cartData[$element.data('product-vendor')][$element.data('variant-id')] = $element.val();
//   });
//   if (!Object.keys(cartData).length) return;
//   const value = { cartItems: cartData }
  
//   console.log(value);
//   // set on localStorage
//   localStorage.setItem(storageKey, JSON.stringify(value));
// }


document.addEventListener('DOMContentLoaded', function() {

  /**
   * Cart form(on submitted)
   */
    const formExpr = '.js-vendor-cart';

    const init = function() {
      if (location.pathname != '/cart') return;
      $('body').on('submit', formExpr, onSubmitted);
    };

    const onSubmitted = async function(e) {
      e.preventDefault();
      const $element = $(e.currentTarget);
      const requestUrl = $element.attr('action');
      const formData = $element.serializeArray();

      console.log(formData);
      // var vendor = $element.data('vendorHandle');
      // for usual MS
      // var lineItemsForLocalStorage = await getLineItemsForLocalStorageByVendor(vendor);
      // for MS-Nap
      var lineItemsForLocalStorage = await searchLineItemsForLocalStorageByCcdTag($element.data('shopCcdTag'));
      console.log("Filtered lineItemsForLocalStorage", lineItemsForLocalStorage);
      // store on localStorage
      const _storageKey = 'MS_APP_CHECKEDOUT_LINE_ITEMS';
      localStorage.setItem(_storageKey, JSON.stringify(lineItemsForLocalStorage));


      const has_rest_split_cart_items = currentCartData.items.length - lineItemsForLocalStorage.length > 0;
      // 新しいデータを追加
      formData.push({ name: "attributes[][key]", value: "_has_rest_split_cart_items" });
      formData.push({ name: "attributes[][value]", value: has_rest_split_cart_items });


      // set cart data on localStorage..
      $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function (data) {
          console.log(data);
          currentCartData = data;

          // store on localStorage
          const storageKey = 'MS_APP_LAST_CART_DATA';
          localStorage.setItem(storageKey, JSON.stringify(currentCartData));
        }
      });

      $.ajax({
        type: 'POST',
        url: requestUrl,
        data: formData
      }).done(onDone);
      return false;
    };

    const onDone = function(responseData, status, jQXhr) {
      if (status != 'success') return;
      if (responseData.checkoutUrl == null) {
        alert('通信に失敗しました。再度お試しください。')
        return;
      }
      // redirect to checkout page..

      window.location.href = responseData.checkoutUrl;
    };

    $(init);


    async function getLineItemsForLocalStorageByVendor(vendor) {
      const cartEndpoint = `/cart.json`;

      try {
        const response = await fetch(cartEndpoint);
        const data = await response.json();

        const lineItems = []; // Storefront APIに合わせた形式のアイテム情報を格納する配列

        data.items.forEach((item) => {
          if (item.vendor === vendor) {
            // 除外したいキーの配列
            const excludeKeys = [
              // 除外したいキーはここに追加
            ];

            // item.properties から excludeKeys に含まれるキーと値が空のものを省略して customAttributes 配列を作成
            const customAttributes = Object.keys(item.properties || {}).filter(key =>
              !excludeKeys.includes(key) && item.properties[key] // 値が空でないこともチェック
            ).map(key => ({
              key: key,
              value: item.properties[key]
            }));

            lineItems.push({
              // variantId: btoa(`gid://shopify/ProductVariant/${item.variant_id}`), // Base64エンコードされたグローバルID
              variantId: item.variant_id, // Base64エンコードされたグローバルID
              quantity: item.quantity,
              customAttributes: customAttributes, // カスタム属性を追加
            });
          }
        });
        return lineItems;
      } catch (error) {
        console.error('Error fetching cart data:', error);
        return [];
      }
    }

    async function searchLineItemsForLocalStorageByCcdTag(ccdTag) {
      const cartEndpoint = `/cart.json`;

      try {
        const lineItems = []; // Storefront APIに合わせた形式のアイテム情報を格納する配列

        document.querySelectorAll("input.js-vendor-cart-quantity-input").forEach(function(input) {

          if (input.dataset.shopCcdTag === ccdTag) {
            // 除外したいキーの配列
            const excludeKeys = [
              // 除外したいキーはここに追加
            ];

            // input.properties から excludeKeys に含まれるキーと値が空のものを省略して customAttributes 配列を作成
            // const customAttributes = Object.keys(input.properties || {}).filter(key =>
            //   !excludeKeys.includes(key) && input.properties[key] // 値が空でないこともチェック
            // ).map(key => ({
            //   key: key,
            //   value: input.properties[key]
            // }));

            lineItems.push({
              // variantId: btoa(`gid://shopify/ProductVariant/${input.variant_id}`), // Base64エンコードされたグローバルID
              variantId: Number(input.dataset.variantId), // Base64エンコードされたグローバルID
              quantity: Number(input.dataset.cartQuantity),
              // customAttributes: customAttributes, // カスタム属性を追加
            });
          }
        });
        return lineItems;
      } catch (error) {
        console.error('Error fetching cart data:', error);
        return [];
      }
    }
  
  /**
   * Vendor name setter
   */
  ;(function() {
    const formExpr = '.js-vendor-cart';
    const labelExpr = '.js-vendor-cart-vendor-name';
    const requestUrl = MS_APP_PROXY_PATH + '/merchants';
    var $forms;
    var vendorHandles = [];

    const init = function() {
      $forms = $(formExpr);
      if (!$forms.length) return;
      $forms.each(function(key, form){
        const $form = $(form);
        vendorHandles.push({ name: 'merchant[short_name][]', value: $form.data('vendor-handle') });
      });
      if (!vendorHandles.length) return;
      $.ajax({
        type: 'GET',
        url: requestUrl,
        data: vendorHandles
      }).done(onDone);
    };

    const onDone = function(responseData, status, jQXhr) {
      if (status != 'success') return;
      _setVendorName(responseData.merchants);
    };

    const _setVendorName = function(merchants) {
      $forms.each(function(key, form){
        const $form = $(form);
        const $labels = $form.find(labelExpr);
        const vendorHandle = $form.data('vendor-handle');
        var vendorName = '';
        $.each(merchants, function(key, merchant){
          if (merchant.short_name == vendorHandle) {
            vendorName = merchant.shop_name;

            const key = `ms_cart_comment_template_${merchant.short_name}`;
            const val = localStorage.getItem(key);
            // set cookie value if exists.. or API default value..
            const html = JSON.parse(val) || merchant.cart_comment_template;
            $('#cart_note_default_' + merchant.short_name).html(html);
            return false;
          }
        });
        $labels.html(vendorName);
      });
    };
    console.log(111);

    $(init);

  })();


  /**
   * Cart form(on quantity changed)
   */
  ;(function() {

    const formExpr = '.js-vendor-cart';
    const inputExpr = '.js-vendor-cart-quantity-input';
    const linkExpr = '.js-vendor-cart-remove-link';
    const requestUrl = '/cart/change.js';
    var xhr = null;

    const init = function() {
      if (location.pathname != '/cart') return;
      $(formExpr).each(function(key, form){
        const $form = $(form);
        $form.on('change', inputExpr, onChanged).
        on('click', linkExpr, onClicked);
      });
    };

    const onChanged = function(e) {
      const $element = $(e.currentTarget);
      _cartUpdate($element.data('variant-id'), $element.val());
    };

    const onClicked = function(e) {
      const $element = $(e.currentTarget);
      _cartUpdate($element.data('variant-id'), 0);
      return false;
    };

    const _cartUpdate = function(itemId, quantity) {
      if (xhr != null) xhr.abort();
      xhr = $.ajax({
        type: 'POST',
        url: requestUrl,
        data: {
          id: itemId,
          quantity: quantity
        }
      }).always(function(jQXhr, status){
        xhr = null;
        if (jQXhr.status == 200) {
          window.location.reload();
        }
      });
    };

    $(init);

  })();
});